export const ConfigMantenedorSucursales = {
   barraBusqueda: {
      criterios: ["Nombre", "Direccion"],
      criteriosKeys: ["nombre", "direccion"],
      criterioPrincipal: "Nombre",
   },
   table: {
      title: "Sucursales",
      add: "Agregar Sucursal",
      options: [
         {
            name: "Importar",
            active: true,
            class: "ft-upload",
         },
         {
            name: "Exportar",
            active: true,
            class: "ft-download",
         },
         {
            name: "Solicitar Soporte",
            active: true,
            class: "ft-shuffle",
         },
      ],
   },
};
